<template>
  <div class="container">
    <header>
      <router-link to="/data-inherit">
        <button
          class="back"
          :style="{ 'background-image': 'url(' + backButtonBGImageSrc + ')' }"
        />
      </router-link>
      {{ this.title }}
    </header>
    <div class="content">
      <p>
        以前利用していた<br />
        アプリ会員 ID・パスワードを入力することで、<br />
        データを引き継ぐことができます。
      </p>

      <div style="display: flex; flex-direction: column; gap: 16px 0;">
        <label>
          アプリ会員ID（半角英数字16桁）
          <input type="text" v-model="formData.userId" placeholder="" />
          <span
            v-show="this.formValidationErrors.userId"
            :style="{
              'background-image': 'url(' + validationErrorBGImageSrc + ')'
            }"
          >
            {{ this.formValidationErrors.userId }}
          </span>
        </label>
        <label>
          パスワード（半角英数字8桁）
          <input type="text" v-model="formData.password" placeholder="" maxlength="8" />
          <span
            v-show="this.formValidationErrors.password"
            :style="{
              'background-image': 'url(' + validationErrorBGImageSrc + ')'
            }"
          >
            {{ this.formValidationErrors.password }}
          </span>
        </label>
      </div>

      <button type="button" class="execute" @click="this.tapSubmit">アプリ会員IDでデータ引き継ぎ</button>

      <span v-if="canSIWA">
        <p style="color: #333333;">
          すでにAppleIDで連携されている方は<br>下記からもデータを引き継ぐことができます。<br>

        </p>
        <p style="margin-top: 14px;">
          <span style="color: #E03535;">機種変更前にID連携されていない方は、<br>データは引き継がれず新規にアカウント連携されます。</span>
        </p>

      </span>

      <button type="button" class="apple-login" v-if="canSIWA" @click="this.tapSIWA">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17.193" style="height: 18px;">
          <path fill="currentColor" d="M14.001 12.611a9.472 9.472 0 0 1-1.191 2.446c-.716 1.048-1.461 2.092-2.632 2.113-1.151.022-1.522-.683-2.837-.683s-1.729.662-2.818.7c-1.131.043-1.992-1.132-2.715-2.176C.332 12.88-.799 8.982.72 6.353A4.2 4.2 0 0 1 4.277 4.2c1.111-.021 2.158.747 2.838.747s1.952-.923 3.291-.788a4.018 4.018 0 0 1 3.145 1.705 3.892 3.892 0 0 0-1.858 3.272 3.794 3.794 0 0 0 2.308 3.475M9.528 2.745A3.781 3.781 0 0 0 10.423 0 3.842 3.842 0 0 0 7.89 1.3a3.6 3.6 0 0 0-.911 2.659 3.189 3.189 0 0 0 2.549-1.214" />
        </svg>
        <span>Apple IDでサインイン</span>
      </button>

      <router-link to="/data-inherit" @click.native="() => { trapTrackEvent(1) }">
        <button type="button" class="cancel" >前の画面に戻る</button>
      </router-link>
    </div>
  </div>
</template>

<script>
import '@/styles/color.css'

import { mapActions, mapGetters } from 'vuex'
import DateFormatter from '../utils/DateFormatter'
import APIClient, { ErrorCode } from '@/api/APIClient'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'DataInheritInput',
  data: function() {
    return {
      title: '会員IDの入力',
      backButtonBGImageSrc: require('@/assets/img/buttons/back@3x.png'),
      validationErrorBGImageSrc: require('@/assets/img/data-inherit/error.png'),
      formData: {
        userId: '',
        password: ''
      },
      formValidationErrors: {
        userId: '',
        password: ''
      },
      versionCheckAlert: false,
      isNeededLineLogin: false,
      canSIWA: false,
      inherited: false
    }
  },
  async created() {
    this.inheritUserByLineLogin()
    const ver42 = await this.actionVer4_2()
    this.isNeededLineLogin = ver42 === 0

    this.inheritUserBySIWA()
    await this.actionCanSIWA()
    this.receivedCanSIWA()
  },
  computed: {
    ...mapGetters({
      lineUid: 'ThirdPartyUid/lineUid',
      siwaUid: 'ThirdPartyUid/siwaUid'
    })
  },
  methods: {
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Native', ['actionRequestToken', 'actionSaveUserId', 'actionVer4_2', 'actionCanSIWA', 'actionRequestSIWA']),
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('ThirdPartyUid', ['setLineUid', 'setSIWAUid']),
    trapTrackEvent(id) {
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createDataInherit())
          break
      }
    },
    validUserId(userId) {
      const re = /^[a-z0-9]{16}$/
      return re.test(userId)
    },
    validPassword(password) {
      const re = /^[a-zA-Z0-9]{8}$/
      return re.test(password)
    },
    tapSubmit() {
      this.formValidationErrors.userId = ''
      this.formValidationErrors.password = ''

      if (!this.validUserId(this.formData.userId)) {
        this.formValidationErrors.userId = 'アプリ会員IDは半角英数字16桁です。'
        return
      }

      this.trackEvent(FactoryTrack.createInheritUser(this.formData.userId))
      this.actionToggleLoading(true)
      const accTime = new DateFormatter().format(new Date())
      const params = {
        apiType: '8',
        acc_time: accTime,
        user_id: this.formData.userId,
        password: this.formData.password || ' '
      }
      try {
        window.receivedToken = payload => {
          const json = JSON.parse(payload)
          this.inheritUser(json)
          window.receivedToken = null
        }
        this.actionRequestToken(params)
      } catch (e) {
        params['app_token'] = ''
      }
      setTimeout(() => {
        this.actionToggleLoading(false)
      }, 300)
    },
    async inheritUser(payload) {
      const token = payload.app_token
      const userId = this.formData.userId
      const password = this.formData.password || ' '
      const accTime = payload.acc_time
      const res = await APIClient.postInheritUser(
        token,
        accTime,
        userId,
        password
      )
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        let payload = res.data.data.user_data.user_id + ','
        if (res.data.data.user_data.hasOwnProperty('reset_password')) {
          payload += res.data.data.user_data.reset_password
        } else {
          payload += password
        }
        this.actionSaveUserId(payload)
      } else {
        this.actionSaveUserId('IDもしくはパスワードに誤りがあります。\nご確認の上もう一度ご入力ください。')
      }
    },
    inheritUserByLineLogin() {
      try {
        window.receivedLineAccessToken = async payload => {
          if (this.inherited) { return }
          const json = JSON.parse(payload)
          this.actionToggleLoading(true)
          const res = await APIClient.postInheritUserByLineLogin(json.app_token, json.acc_time, json.user_id, json.line_access_token)
          this.actionToggleLoading(false)
          if (res.status === 200 && res.data.data.code === ErrorCode.CODE_SUCCESS) {
            if (res.data.data.user_data) {
              let payload = res.data.data.user_data.user_id + ',' + res.data.data.user_data.reset_password
              this.actionSaveUserId(payload)
            } else if (res.data.data.line_uid) {
              this.setLineUid(res.data.data.line_uid)
              this.$router.push({ name: 'WalkThrough' })
            }
            this.inherited = true
          } else {
            this.actionSaveUserId('LINE アカウント連携に失敗しました')
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    inheritUserBySIWA() {
      try {
        window.receivedSIWAIdToken = async payload => {
          if (this.inherited) { return }
          const json = JSON.parse(payload)
          this.actionToggleLoading(true)
          const res = await APIClient.postInheritUserBySIWA(json.app_token, json.acc_time, json.user_id, json.id_token, json.nonce)
          this.actionToggleLoading(false)

          if (res.status === 200 && res.data.data.code === ErrorCode.CODE_SUCCESS) {
            if (res.data.data.user_data) {
              let payload = res.data.data.user_data.user_id + ',' + res.data.data.user_data.reset_password
              this.actionSaveUserId(payload)
            } else if (res.data.data.siwa_uid) {
              this.setSIWAUid(res.data.data.siwa_uid)
              this.$router.push({ name: 'WalkThrough' })
            }
            this.inherited = true
          } else {
            this.actionSaveUserId('Apple ID連携に失敗しました')
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    receivedCanSIWA() {
      try {
        window.receivedCanSIWA = payload => {
          this.canSIWA = payload === 'true'
        }
      } catch (e) {
        console.log(e)
      }
    },
    async tapSIWA() {
      this.trackEvent(FactoryTrack.createSIWA())
      if (this.canSIWA) {
        await this.actionRequestSIWA()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  font-family: HiraKakuPro-W6;
  font-size: 15px;
  font-weight: bold;
  color: #333333;
  border-bottom: 1px #dddddd solid;
  background-color: #ffffff;

  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    position: absolute;
    left: 0;

    button.back {
      height: 44px;
      width: 44px;
      background: none;
      border: none;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 8px 14px;
    }
  }
}

.container {
  position: relative;
  min-height: 100%;
  background-color: #ffffff;

  .content {
    padding: 30px 28px;
    display: flex;
    flex-direction: column;
    gap: 24px 0;

    p:first-child {
      font-size: 14px;
      font-weight: 300;
    }

    p {
      text-align: center;
      color: #333333;
      font-size: 13px;
    }

    p:last-child {
      color: var(--error-text-color);
    }
  }
}

label {
  display: block;
  text-align: left;
  color: var(--accent-color);
  font-size: 11px;

  span {
    display: block;
    color: #e03535;
    font-size: 11px;
    font-weight: bold;
    padding-top: 5px;
    padding-left: 16px;
    background-repeat: no-repeat;
    background-size: 12px;
    background-position: left 6px;
  }
}

input[type='text'] {
  font-size: 14px;
  width: 100%;
  height: 41px;
  padding: 12px;
  letter-spacing: 1px;
  font-family: HiraKakuPro-W6;
  background-color: var(--background-color);
  appearance: none;
  border: 1px solid var(--accent-color);
  border-radius: 4px;
  font-weight: bold;
  outline: none;
  margin-top: 5px;
}

button {
  border: none;
  cursor: pointer;
}

button.execute {
  width: 100%;
  background: var(--accent-color);
  border-radius: 5px;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  padding: 14px 0;
}

button.cancel {
  color: #333333;
  font-size: 14px;
  font-weight: 300;
  background: none;
  border-bottom: 1px solid #333333;
}

button.apple-login {
  background-color: #001000;
  color: white;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 0 6px;
  justify-content: center;
  padding: 14px 0;
  font-size: 14px;
  font-weight: 600;
}
</style>
